export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12116.1fc2f89f.jpg";